<script lang="ts">
  export let color: 'light' | 'dark' | 'brand' = 'light';
</script>

<div
  class="feature-box-card"
  class:c-dark={color === 'dark'}
  class:c-brand={color === 'brand'}
>
  <div class="feature-card-content space-y-2">
    {#if $$slots['text-secondary']}
      <span class="feature-secondary">
        <slot name="text-secondary" />
      </span>
    {/if}
    {#if $$slots['kpi']}
      <span class="feature-kpi">
        <slot name="kpi" />
      </span>
    {/if}
    {#if $$slots['title']}
      <span class="feature-title">
        <slot name="title" />
      </span>
    {/if}
    {#if $$slots['text']}
      <span class="feature-text">
        <slot name="text" />
      </span>
    {/if}
  </div>
</div>

<style type="text/scss" lang="scss" scoped>
  .feature-box-card {
    @apply relative;
    @apply text-center;
    @apply bg-white;

    &::before {
      content: '';
      @apply block w-0;
      @apply pb-full;
    }

    &.c-dark {
      @apply bg-tint;
      @apply text-contrast-tint;
    }

    &.c-brand {
      @apply bg-brand;
    }
  }

  .feature-card-content {
    @apply absolute inset-0;
    @apply p-12 md:p-6 xl:p-12;
    @apply flex flex-col items-center justify-center;
  }

  .feature-kpi {
    @apply font-serif font-medium text-[3rem];
    @apply leading-none;
    @apply lg:text-7xl;
  }

  .feature-title {
    @apply font-serif font-medium text-2xl;
    @apply leading-none;
    @apply lg:text-5xl;
  }

  .feature-text {
    @apply font-serif font-medium text-lg;
    @apply leading-tight;
  }

  .feature-kpi + .feature-text,
  .feature-title + .feature-text {
    @apply font-sans font-normal text-base;
    @apply leading-relaxed;
  }

  .feature-secondary {
    @apply font-sans font-normal text-base;
    @apply leading-relaxed;
  }
</style>
